

















































// @ts-ignore
import PlayIcon from '@/assets/icons/play.svg';
// @ts-ignore
import CalendarIcon from '@/assets/icons/calendar.svg';


import { computed, defineComponent, PropType } from '@vue/composition-api';
import ExpandableText from '@/components/ExpandableText.vue';
import ShareButton from '@/components/ShareButton.vue';
import SocialShareButtons from '@/components/SocialShareButtons.vue';
import SocialShareInfo from '@/data/SocialShareInfo';
import SharedState from '@/data/SharedState';
export default defineComponent({
    components: {
      PlayIcon, CalendarIcon, ExpandableText, ShareButton, SocialShareButtons
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      views: {
        type: Number,
        default: undefined
      },
      dateAddedMs: {
        type: Number,
        default: undefined
      },
      description: {
        type: String,
        default: ''
      },
      showSocialShareButtons: {
        type: Boolean,
        default: false
      },
      socialShareInfo: {
        type: Object as PropType<SocialShareInfo>,
        required: true
      },
      locale: {
        type: String,
        default: undefined
      }
    },
    emits: {
      'share-video': () => true,
      'share-video-social': () => true
    },
    setup(props, context) {
      const viewsValue = computed(() => {
        return props.views + ' ' + SharedState.getText(context, 'corptube.views');;
      });
      const localDate = computed(() => {
        return new Date(props.dateAddedMs).toLocaleDateString(props.locale);
      });
      return {
        viewsValue,
        localDate
      }
    }

  });
